import { render, staticRenderFns } from "./grid.vue?vue&type=template&id=96bcc74a&scoped=true&"
var script = {}
import style0 from "./grid.vue?vue&type=style&index=0&id=96bcc74a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96bcc74a",
  null
  
)

export default component.exports